import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import language from "../../language";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchRequestedProducts = async (
  lng = "english",
  { page, limit, type, id, q, request, forwadedRequest }
) => {
  try {
    const user = await getStorage();

    const options = {
      method: "GET",
      url: `${API_URL}/product-request`,
      params: {
        page: page,
        limit: limit,
        id,
        q,
        request,
        forwadedRequest,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    let { data, count, totalRecords } = queryRes.data;

    if (type === "dropdown") {
      return queryRes.data.map((el) => {
        return {
          ...el,
          label: el.code + " - " + el.name,
          value: el._id,
        };
      });
    }

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deleteRequestedProducts = async (lng = "english", data) => {
  try {
    const user = await getStorage();
    console.log("Should return data", data);
    const options = {
      method: "DELETE",
      url: `${API_URL}/product-request`,
      data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_data);
  } catch (error) {
    toastMessage("error", error);
  }
};

export const fetchBloodRequest = async (
  lng = "english",
  { page, limit, id, q, requestNo }
) => {
  try {
    const user = await getStorage();

    const options = {
      method: "GET",
      url: `${API_URL}/bloodRequest`,
      params: {
        page: page,
        limit: limit,
        id,
        q,
        requestNo,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    let { data, count, totalRecords } = queryRes.data;

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", error);
  }
};
